var map = {
	"./animal-from-the-sea.pdf": 10093,
	"./animals-of-the-forest.pdf": 77195,
	"./colouring-stickers.pdf": 90265,
	"./dialogue-cards.pdf": 54197,
	"./facial-expression.pdf": 81646,
	"./flipover-illustrations.pdf": 4241,
	"./massage-history.pdf": 95890,
	"./massage-history2.pdf": 46924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32915;